"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCSS = exports.isJS = exports.getAssetsTypeByExtension = exports.getExtension = exports.filterWebpackRuntimeAsset = exports.getComponentAssetsOrder = exports.filterModelAssets = exports.filterStyleAssets = exports.filterPartAssets = exports.filterComponentAssets = exports.filterDependencyAssets = exports.filterChunkAssets = void 0;
function filterChunkAssets(assets, name) {
    return assets.filter(function (asset) { return (name ? asset.chunk === name : !!asset.chunk); });
}
exports.filterChunkAssets = filterChunkAssets;
function filterDependencyAssets(assets) {
    return assets.filter(function (asset) { return !!asset.dependency; });
}
exports.filterDependencyAssets = filterDependencyAssets;
function filterComponentAssets(assets) {
    return assets.filter(function (asset) { return !asset.part && !asset.dependency; });
}
exports.filterComponentAssets = filterComponentAssets;
function filterPartAssets(assets, part) {
    return assets.filter(function (asset) { return (part ? asset.part === part : !!asset.part); });
}
exports.filterPartAssets = filterPartAssets;
function filterStyleAssets(assets) {
    return assets.filter(function (asset) { return asset.type === 'style' && isCSS(asset.extension); });
}
exports.filterStyleAssets = filterStyleAssets;
function filterModelAssets(assets) {
    return assets.filter(function (asset) { return asset.type === 'model' && isJS(asset.extension); });
}
exports.filterModelAssets = filterModelAssets;
function getComponentAssetsOrder(assets) {
    return __spreadArray(__spreadArray([], assets.filter(function (asset) { return asset.chunk && !asset.part; })), assets.filter(function (asset) { return !asset.chunk && !asset.part; }));
}
exports.getComponentAssetsOrder = getComponentAssetsOrder;
function filterWebpackRuntimeAsset(assets) {
    return assets.filter(function (asset) { return asset.type === 'webpack-runtime'; });
}
exports.filterWebpackRuntimeAsset = filterWebpackRuntimeAsset;
function getExtension(url) {
    return url.split('.').pop();
}
exports.getExtension = getExtension;
function getAssetsTypeByExtension(extension) {
    if (isJS(extension)) {
        return 'model';
    }
    else if (isCSS(extension)) {
        return 'style';
    }
    else {
        return 'unknown';
    }
}
exports.getAssetsTypeByExtension = getAssetsTypeByExtension;
function isJS(extension) {
    return extension === 'js';
}
exports.isJS = isJS;
function isCSS(extension) {
    return extension === 'css';
}
exports.isCSS = isCSS;
//# sourceMappingURL=assets.js.map